import React from 'react';
import SectionTitle from './SectionTitle';
import ScrollReveal from './ScrollReveal';

const CVSection = () => {
  return (
    <section id="cv" className="section" style={styles.section}>
      <ScrollReveal>
        <SectionTitle text="CV" />
      </ScrollReveal>

      <div style={styles.gridContainer}>
        <ScrollReveal delay={300}>
          <div style={styles.gridItem}>
            <h3 style={styles.gridHeading}>EXPERIENCE</h3>
            <div style={styles.experienceGrid}>
              <div style={styles.experienceItem}>
                <div style={styles.year}>2025</div>
                <div style={styles.position}>Security Researcher</div>
                <div style={styles.company}>OX Security</div>
                <div style={styles.description}>Specializing in Container, Cloud and Kubernetes Security. Focusing on container security research, vulnerability assessment, and risk mitigation strategies.</div>
              </div>
              <div style={styles.experienceItem}>
                <div style={styles.year}>2023 - 2025</div>
                <div style={styles.position}>Security Researcher</div>
                <div style={styles.company}>KTrust</div>
                <div style={styles.description}>Created realistic attack scenarios and automated them to simulate real-world attacks in sandboxed customer Kubernetes and Cloud environments.</div>
              </div>
              <div style={styles.experienceItem}>
                <div style={styles.year}>2022 - 2023</div>
                <div style={styles.position}>Red Team Engineer</div>
                <div style={styles.company}>10Root Cyber Security</div>
                <div style={styles.description}>Performed offensive security operations, penetration testing, and security assessments. Identified vulnerabilities in client systems and infrastructure, and provided remediation recommendations to improve security posture.</div>
              </div>
              <div style={styles.experienceItem}>
                <div style={styles.year}>2019 - 2022</div>
                <div style={styles.position}>Red Team Engineer</div>
                <div style={styles.company}>IAF</div>
                <div style={styles.description}>Served in the Israel Air Force (IAF) cyber security unit. Led offensive security exercises, developed security testing procedures, and trained team members in advanced penetration testing techniques. Performed security assessments on critical systems and infrastructure.</div>
              </div>
            </div>
          </div>
        </ScrollReveal>
        
        <ScrollReveal delay={500}>
          <div style={styles.gridItem}>
            <h3 style={styles.gridHeading}>SKILLS</h3>
            <div style={styles.skillsContainer}>
              <div style={styles.skillCategory}>
                <h4 style={styles.skillCategoryTitle}>Programming</h4>
                <div style={styles.skillsList}>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Go
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Python
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> C/C++
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> C#
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Rust
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Assembly
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> PowerShell
                  </div>
                </div>
              </div>
              
              <div style={styles.skillCategory}>
                <h4 style={styles.skillCategoryTitle}>Security</h4>
                <div style={styles.skillsList}>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Red Teaming
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Exploit Development
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Penetration Testing
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> OSINT
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Reverse Engineering
                  </div>
                </div>
              </div>
              
              <div style={styles.skillCategory}>
                <h4 style={styles.skillCategoryTitle}>Tools & Technologies</h4>
                <div style={styles.skillsList}>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Kubernetes
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Docker
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> IDA
                  </div>
                  <div style={styles.skill}>
                    <span style={styles.skillBullet}>▲</span> Burp Suite
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '3rem 1rem',
    maxWidth: '1200px',
    margin: '0 auto 4rem',
    position: 'relative',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
  },
  gridItem: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '1px solid #0ff', // Neon blue
    padding: '1.5rem',
    borderRadius: '5px',
  },
  gridHeading: {
    color: '#0ff', // Neon blue
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  experienceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '1.5rem',
  },
  experienceItem: {
    padding: '1rem',
    border: '1px solid rgba(0, 255, 255, 0.3)',
    borderRadius: '5px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  year: {
    color: '#ff0', // Neon yellow
    fontWeight: 'bold',
    marginBottom: '0.2rem',
  },
  position: {
    color: '#0ff', // Neon blue
    fontWeight: 'bold',
    marginBottom: '0.2rem',
  },
  company: {
    color: '#f0f', // Neon pink
    marginBottom: '0.5rem',
  },
  description: {
    fontSize: '0.9rem',
    color: '#e0e0e0',
  },
  skillsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '1.5rem',
  },
  skillCategory: {
    marginBottom: '1rem',
  },
  skillCategoryTitle: {
    color: '#f0f', // Neon pink
    marginBottom: '0.8rem',
    borderBottom: '1px solid #f0f',
    paddingBottom: '0.3rem',
  },
  skillsList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '0.5rem',
  },
  skill: {
    marginBottom: '0.5rem',
    color: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
  },
  skillBullet: {
    color: '#0ff',
    marginRight: '0.5rem',
    textShadow: '0 0 5px #0ff',
  }
};

export default CVSection; 
